import {
  getContextualSegmentKey,
  resolveContextualProviderId,
} from '@openx/components-targeting/Targeting/ContextualSegments/utils/enrichment';
import type { SegmentsOptions } from '@openx/types/targeting/customVariables';
import type { getIncludedContextualSegments } from './getIncludedContextualSegments';

export const getContextualMaxPom = (
  segments: SegmentsOptions,
  { keys, providerIds }: ReturnType<typeof getIncludedContextualSegments>
): number | null => {
  const pomValues = segments.reduce((acc: number[], segment) => {
    const providerId = resolveContextualProviderId(segment, providerIds);
    const isIncluded = !!providerId && keys.has(getContextualSegmentKey({ providerId, segmentId: segment.id }));

    if (isIncluded && typeof segment.price_pom === 'number' && Number.isFinite(segment.price_pom)) {
      acc.push(segment.price_pom);
    }

    return acc;
  }, []);

  return pomValues.length > 0 ? Math.max(...pomValues) : null;
};
